import { render, staticRenderFns } from "./CharacterList.vue?vue&type=template&id=38fa9892&scoped=true"
import script from "./CharacterList.vue?vue&type=script&lang=ts"
export * from "./CharacterList.vue?vue&type=script&lang=ts"
import style0 from "./CharacterList.vue?vue&type=style&index=0&id=38fa9892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa9892",
  null
  
)

export default component.exports